/* tslint:disable */
/* eslint-disable */
export enum WorkSearchCategoryEnum {
  ContactAndProjects = 'contactAndProjects',
  Items = 'items',
  Users = 'users',
  Equipments = 'equipments',
  Stocklocations = 'stocklocations'
}
